export default __webpack_public_path__ + "static/system-e6c889d7f9515aae547b156a79991f4b.webp";